import React from 'react';
import { Screen } from '../enums/screen.enum';
import { useTranslation, Trans } from 'react-i18next';
import ContentContainer from '../partials/ContentContainer';
import ActionsContainer from '../partials/ActionsContainer';
import { Button, ButtonGroup, ButtonVariant } from '../components/Button';
import ScreenContainer from '../partials/ScreenContainer';
import { useLocalStorage } from '@uidotdev/usehooks';
import { Constat } from '../models/Constat';
import { Vehicle } from '../models/Vehicle';
import VehicleContainer, {
  VehicleContainerVariant,
} from '../partials/VehicleContainer';
import { VehicleIcon } from '../components/VehicleIcon';
import { PhotosUploader } from '../components/PhotosUploader';
import { Textarea } from '../components/Textarea';

export default function Step8DamagesBScreen({
  isActive,
  setScreen,
}: {
  isActive: boolean;
  setScreen: (screen: Screen) => void;
}) {
  const { t } = useTranslation();
  const [constat, setConstat] = useLocalStorage('constat', new Constat());

  const handlePhotosChange = (photos: string[]) =>
    setConstat((prevConstat) => {
      const newConstat = new Constat(prevConstat);
      if (!newConstat.vehicleB) {
        newConstat.vehicleB = new Vehicle();
      }
      newConstat.vehicleB.damagePictures = photos;
      return newConstat;
    });

  const handleComment = (value: string) => {
    setConstat((prevConstat) => {
      const newConstat = new Constat(prevConstat);
      if (!newConstat.vehicleB) {
        newConstat.vehicleB = new Vehicle();
      }
      newConstat.vehicleB.visibleDamage = value;
      return newConstat;
    });
  };

  return !isActive ? (
    <></>
  ) : (
    <ScreenContainer
      title={
        <Trans i18nKey={'screens.step8-damages-b.title'}>
          <strong></strong>
        </Trans>
      }
      timelineStep={8}
      extraCssClasses={['screen-step', 'step8-damages-b']}
    >
      <ContentContainer>
        <VehicleContainer variant={VehicleContainerVariant.B}>
          <h2>
            <VehicleIcon shape={constat.vehicleB?.vehicleShape}></VehicleIcon>
            {t('screens.step8-damages-b.second-title')}
          </h2>
        </VehicleContainer>
        <PhotosUploader
          id="constat-vehicle-b-damage-photos"
          name="constat-vehicle-b-damage-photos"
          photos={constat.vehicleB?.damagePictures ?? []}
          onPhotosChange={handlePhotosChange}
          multiple={true}
        ></PhotosUploader>

        <Textarea
          label={t('screens.step8-damages-b.instructions')}
          name="visibleDamage"
          id="visibleDamage"
          value={constat.vehicleB?.visibleDamage || ''}
          onChange={(value) => handleComment(value)}
        />
      </ContentContainer>

      <ActionsContainer>
        <ButtonGroup>
          <Button
            variant={ButtonVariant.Green}
            isOutlined
            onClick={() => setScreen(Screen.step7InitialImpactB)}
          >
            {t('common.previous')}
          </Button>

          <Button
            variant={ButtonVariant.Green}
            onClick={() => setScreen(Screen.step9Chatbot)}
          >
            {t('common.next')}
          </Button>
        </ButtonGroup>
      </ActionsContainer>
    </ScreenContainer>
  );
}
